// export const API_DEV_URL = "http://localhost:8080";
export const API_DEV_URL = "https://api.logistics.trackifyassets.com";
// export const API_DEV_URL ="http://192.168.2.20:8080";
export const GOOGLE_MAP_ACCESS_TOKEN =  "AIzaSyDKxCHOI2qUv06bvtYbo_yXcd4eTPUuhxk";
export const API_USER_SERVICE = `${API_DEV_URL}/api/v1`;